import React from 'react';
import AbsoluteFooter from '../../components/Footer/AbsoluteFooter';

function Thankyou() {

    return (
        <div className="secondary-bg">
            <div className="w-full h-[100vh] flex justify-center items-center">
                <div className="text-xl text-center my-5 p-5">
                    <span className="text-white">
                        Thank you for reaching out to us.&nbsp;
                    </span>
                    <br />
                    We will be in contact with you shortly to address your needs.
                </div>
                <div className="fixed w-full top-0 left-0">
                    <div className="flex justify-center p-5">
                        <img src="/assets/images/logo/dodeal-white.png" alt="DoDeal" className="w-[100px]" />
                    </div>
                </div>
                <AbsoluteFooter />
            </div>
        </div>
    );
}

export default Thankyou;
